import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { syncDocumentLanguage } from '@koob/utils';

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'en',
  defaultNS: 'shared',
  // React already escapes everything it renders, so i18next's own escaping is
  // pure damage here: it turns any interpolated `/`, `'`, `&`, `<`, `>` or `"`
  // into an entity that reaches the DOM as literal text — a date interpolated
  // into a label came out as `09&#x2F;09&#x2F;2026`. The only sites that build
  // raw HTML (dangerouslySetInnerHTML) inject API content, never `t()` output.
  interpolation: { escapeValue: false },
  resources: {
    fr: require('./locales/fr.json'),
    en: require('./locales/en.json'),
  },
});

// Keep <html lang> accurate from the first paint (accessibility + future i18n).
// Browser translation itself is fully disabled at the document level via
// translate="no" + the notranslate meta in index.html.
syncDocumentLanguage('en');

export default i18n;
